<template>
  <v-data-table :headers="headers" :items="results" class="elevation-3">
    <template v-slot:item.mirn="{ item }"
      ><button type="button" small v-clipboard:copy="getMirn(item)" class="mr-3">
        <v-icon>far fa-copy</v-icon>
      </button>
      {{ getMirn(item) }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'DisplayResults',
  props: { results: Array, isShowCheckSum: Boolean },
  data() {
    return {
      sort_desc: true,
      headers: [
        {
          text: 'Mirn',
          sortable: true,
          value: 'mirn',
          class: 'subtitle-1 font-weight-bold ',
        },
        {
          text: 'Address',
          sortable: true,
          value: 'address',
          class: 'subtitle-1 font-weight-bold ',
        },
        {
          text: 'Gas Meter',
          sortable: true,
          value: 'gasmeternumber',
          class: 'subtitle-1 font-weight-bold ',
        },
      ],
    };
  },
  methods: {
    getMirn(item) {
      if (this.isShowCheckSum) {
        return `${item.mirn}${item.mirnCheckSum}`;
      } else {
        return item.mirn;
      }
    },
  },
};
</script>

<style scoped></style>
